import { render, staticRenderFns } from "./TheXe.vue?vue&type=template&id=70750824&scoped=true"
import script from "./TheXe.vue?vue&type=script&lang=js"
export * from "./TheXe.vue?vue&type=script&lang=js"
import style0 from "./TheXe.vue?vue&type=style&index=0&id=70750824&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70750824",
  null
  
)

export default component.exports